import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class LinkInvoiceToCertificationItemDto {
  @Expose()
  invoiceId: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  allocatedAmount: number;
}
